module.exports = __webpack_public_path__ + "img/mobile-map-parking-pin.e5b31c59.svg";